import React, { useMemo, useState } from 'react';
import { AgCharts } from 'ag-charts-react';
import { IEmissionsOfEcaSeaAreas } from '../../../../greenTypes';
import { formatBigNumbersToString, formatValueAsString } from '../../../../../../utils/helpers';
import { AgChartOptions } from 'ag-charts-community';
import { CHART_COLORS } from '../../../../../../constants/constants';

interface IEmissionByEcaChartProps {
	data: IEmissionsOfEcaSeaAreas[];
}

const EmissionByEcaChart: React.FC<IEmissionByEcaChartProps> = ({ ...props }) => {
	const formatOptions = useMemo(() => ({ minimumFractionDigits: 0, maximumFractionDigits: 2 }), []);

	const transformedData = [
		props.data.reduce(
			(acc: any, curr) => {
				acc[curr.ecaSeaArea] = curr.sumOfEmission;
				return acc;
			},
			{ type: 'SeaAreas' },
		),
	];

	const seaAreas = Object.keys(transformedData[0]).filter((key) => key !== 'type');

	const [options] = useState<AgChartOptions>({
		data: transformedData,
		title: {
			text: 'CO2 Emissions by ECA (Tank-to-Wake)',
			textAlign: 'left',
			fontSize: 14,
			spacing: 15,
		},
		series: seaAreas.map((seaArea, index) => ({
			type: 'bar',
			direction: 'horizontal',
			xKey: 'type',
			yKey: seaArea,
			yName: seaArea,
			stacked: true,
			fill: CHART_COLORS[index],

			tooltip: {
				renderer(params) {
					return {
						data: undefined,
						title: seaArea,
						heading: formatValueAsString(params.datum[seaArea], formatOptions, '', '', ''),
					};
				},
			},
		})),
		axes: [
			{
				type: 'category',
				position: 'left',
				label: {
					enabled: false,
				},
			},
			{
				type: 'number',
				position: 'bottom',
				label: {
					formatter: ({ value }: { value: number }) => {
						return formatBigNumbersToString(value);
					},
				},
				nice: false,
			},
		],
		legend: {
			position: 'bottom',
			spacing: 15,
			item: {
				// label: {
				// 	fontSize: 10,
				// },
				marker: {
					shape: 'circle',
					size: 10,
				},
			},
		},
		padding: { top: 0, bottom: 0, left: 5, right: 10 },
	});

	return <AgCharts options={options} className="w-full h-full" style={{ height: '140px' }} />;
};

export default EmissionByEcaChart;
